import React from "react";
import "../components/Styles/StartupDocuments.css";
import {
  FaBuilding,
  FaFileContract,
  FaShieldAlt,
  FaHandshake,
  FaClipboardCheck,
  FaUserTie,
  FaArrowRight,
} from "react-icons/fa";

function StartupDocuments() {
  const documents = [
    {
      title: "Founders Agreement",
      price: "₹2999",
      oldPrice: "₹6999",
      icon: <FaHandshake />,
      features: [
        "Clearly define founder roles",
        "Avoid future conflicts",
        "Equity & ownership protection",
        "Legally drafted by experts",
      ],
    },
    {
      title: "Privacy Policy",
      price: "₹3999",
      oldPrice: "₹7999",
      icon: <FaShieldAlt />,
      features: [
        "Website legal protection",
        "GDPR compliant drafting",
        "Protect user data legally",
        "Drafted by professionals",
      ],
    },
    {
      title: "Terms & Conditions",
      price: "₹4999",
      oldPrice: "₹9999",
      icon: <FaFileContract />,
      features: [
        "Protect your platform legally",
        "Clear user policies",
        "Reduce legal risks",
        "Professional legal drafting",
      ],
    },
    {
      title: "Shareholder Agreement",
      price: "₹6999",
      oldPrice: "₹14999",
      icon: <FaBuilding />,
      features: [
        "Investor protection",
        "Shareholding clarity",
        "Exit & transfer clauses",
        "Business security",
      ],
    },
    {
      title: "Employment Contract",
      price: "₹2499",
      oldPrice: "₹5999",
      icon: <FaUserTie />,
      features: [
        "Legally hire employees",
        "Protect company rights",
        "Professional HR contracts",
        "Easy onboarding process",
      ],
    },
    {
      title: "Vendor Agreement",
      price: "₹3499",
      oldPrice: "₹7999",
      icon: <FaClipboardCheck />,
      features: [
        "Secure vendor partnerships",
        "Payment term protection",
        "Avoid legal disputes",
        "Custom agreement drafting",
      ],
    },
  ];

  return (
    <div className="startup-page">

      {/* Hero Section */}
      <section className="startup-hero">
        <div className="container">
          <div className="hero-content">

            <span className="hero-tag">
              Professional Startup Documentation
            </span>

            <h1>
              Startup Legal Documents <br />
              For Every Business Need
            </h1>

            <p>
              Get professionally drafted startup documents from expert
              corporate lawyers. Fast delivery, affordable pricing,
              and complete legal protection for your business.
            </p>

            <button>
              Explore Documents <FaArrowRight />
            </button>

          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section className="startup-documents">
        <div className="container">

          <div className="section-heading">
            <h2>Popular Startup Documents</h2>
            <p>
              Professional legal drafting services for startups,
              businesses, founders, and entrepreneurs.
            </p>
          </div>

          <div className="documents-grid">

            {documents.map((doc, index) => (
              <div className="document-card" key={index}>

                <div className="doc-icon">
                  {doc.icon}
                </div>

                <h3>{doc.title}</h3>

                <div className="price-box">
                  <span className="new-price">{doc.price}</span>
                  <span className="old-price">{doc.oldPrice}</span>
                </div>

                <ul>
                  {doc.features.map((feature, i) => (
                    <li key={i}>✔ {feature}</li>
                  ))}
                </ul>

                <button className="know-btn">
                  Know More
                </button>

              </div>
            ))}

          </div>
        </div>
      </section>

          {/* ================= WHY CHOOSE LegalAxis ================= */}

<section className="lk-startup-why-section">

  <div className="container">

    <div className="lk-startup-heading">
      <h2>Why Choose LegalAxis?</h2>
    </div>

    <div className="lk-startup-why-grid">

      <div className="lk-startup-why-card">
        <h3>Expert Lawyers</h3>

        <p>
          Documents drafted by experienced startup and corporate lawyers.
        </p>
      </div>

      <div className="lk-startup-why-card">
        <h3>Fast Delivery</h3>

        <p>
          Get your legal documents delivered within committed timelines.
        </p>
      </div>

      <div className="lk-startup-why-card">
        <h3>Affordable Pricing</h3>

        <p>
          Professional legal drafting services at startup-friendly pricing.
        </p>
      </div>

      <div className="lk-startup-why-card">
        <h3>Custom Drafting</h3>

        <p>
          Tailor-made agreements and documents as per your requirements.
        </p>
      </div>

    </div>

  </div>

</section>

{/* ================= CTA SECTION ================= */}

<section className="lk-startup-custom-cta">

  <div className="container">

    <div className="lk-startup-cta-wrapper">

      <div className="lk-startup-cta-content">

        <h2>
          Need Custom Startup Documentation?
        </h2>

        <p>
          Talk with our expert legal professionals and get your
          startup documents drafted professionally.
        </p>

        <button>
          Chat Now
        </button>

      </div>

      <div className="lk-startup-cta-image">

        <img
          src="https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1200&auto=format&fit=crop"
          alt="Startup Legal"
        />

      </div>

    </div>

  </div>

</section>

    </div>
  );
}

export default StartupDocuments;